(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["launch-waitlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'lugg_wl_notified';

    // ── localStorage dedupe helpers ──────────────────────────────────────────
    // Keyed by "email::product_id" so the same browser can still sign up a
    // different email for the same product (shared devices), but the same
    // email can't fire repeat requests for a product it's already on the
    // list for.
    function getNotifiedList() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function saveNotifiedList(list) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {
        // Storage unavailable (private mode / quota / disabled) — fail open,
        // dedupe just won't persist for this visit.
      }
    }

    function notifiedKey(email, productId) {
      return email.trim().toLowerCase() + '::' + productId;
    }

    function isAlreadyNotified(email, productId) {
      return getNotifiedList().indexOf(notifiedKey(email, productId)) !== -1;
    }

    function markNotified(email, productId) {
      var list = getNotifiedList();
      var key = notifiedKey(email, productId);
      if (list.indexOf(key) === -1) {
        list.push(key);
        saveNotifiedList(list);
      }
    }

    function initWaitlistLaunch(root) {
      if (!root || root.dataset.wlInit) return;
      root.dataset.wlInit = '1';

      var emailEl    = root.querySelector('[data-wl-email]');
      var submitBtn  = root.querySelector('[data-wl-submit]');
      var errEl      = root.querySelector('[data-wl-error]');
      var errTextEl  = root.querySelector('[data-wl-error-text]');
      var okEl       = root.querySelector('[data-wl-success]');
      var okTextEl   = root.querySelector('[data-wl-success-text]');
      var fieldWrap  = root.querySelector('[data-wl-field-wrapper]');
      var btnLabel   = root.querySelector('[data-wl-btn-text]');
      var honeypotEl = root.querySelector('[data-wl-honeypot]');

      if (!emailEl || !submitBtn) return;

      var cfg  = window.__lugg_nm || {};
      var BASE = (cfg.baseUrl || 'https://keplin-mcp.mo-3e5.workers.dev').replace(/\/$/, '');
      var AUTH = cfg.auth || '';

      if (cfg.customerEmail) emailEl.value = cfg.customerEmail;

      function showError(msg) {
        if (errTextEl) errTextEl.textContent = msg;
        if (errEl) errEl.style.display = 'flex';
      }
      function clearError() {
        if (errEl) errEl.style.display = 'none';
      }
      function setLoading(loading) {
        submitBtn.disabled = loading;
        if (btnLabel) btnLabel.textContent = loading ? 'Sending…' : 'NOTIFY ME';
      }
      function checkedBoxes() {
        return Array.prototype.slice.call(root.querySelectorAll('[data-wl-checkbox]:checked'));
      }
      function showSuccess(msg) {
        if (fieldWrap) fieldWrap.style.display = 'none';
        if (okTextEl) okTextEl.textContent = msg;
        if (okEl) okEl.style.display = 'flex';
      }

      function subscribeOne(box, email) {
        var productTitle = box.dataset.nmProductTitle || '';
        var variantTitle  = box.dataset.nmVariantTitle || productTitle;
        var payload = {
          email:          email,
          variant_id:     box.dataset.nmVariantId    || '',
          product_id:     box.dataset.nmProductId    || '',
          product_title:  productTitle,
          variant_title:  variantTitle,
          product_handle: box.dataset.nmProductHandle || '',
          product_url:    box.dataset.nmProductUrl   || ''
        };
        if (cfg.customerId) payload.customer_id = cfg.customerId;

        return fetch(BASE + '/lugg/oos/subscribe', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'X-MCP-Auth': AUTH },
          body:    JSON.stringify(payload)
        })
          .then(function (res) {
            return res.json().then(function (d) {
              return { ok: res.ok, data: d, productTitle: productTitle, payload: payload };
            });
          })
          .catch(function () {
            return { ok: false, data: null, productTitle: productTitle, payload: payload };
          });
      }

      function handleSubmit(e) {
        if (e) e.preventDefault();
        clearError();

        // Honeypot: real visitors never see or fill this field. If it has a
        // value, silently bail — no request, no feedback, nothing for a bot
        // to learn from.
        if (honeypotEl && honeypotEl.value) {
          return;
        }

        var email = (emailEl.value || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError('Please enter a valid email address.');
          emailEl.focus();
          return;
        }

        var boxes = checkedBoxes();
        if (!boxes.length) {
          showError('Please select at least one product to be notified about.');
          return;
        }

        // Silently drop anything this email has already been subscribed to
        // from this browser — no API call, no distinct message for these.
        var boxesToSubmit = boxes.filter(function (box) {
          return !isAlreadyNotified(email, box.dataset.nmProductId);
        });
        var alreadyCount = boxes.length - boxesToSubmit.length;

        if (!boxesToSubmit.length) {
          // Everything selected was already submitted for this email — treat
          // it the same as a normal success (it's true — they are on the
          // list) without firing any network request.
          showSuccess(alreadyCount === 1
            ? "You're on the list! We'll email you when it launches."
            : "You're on the list for " + alreadyCount + " items! We'll email you as each one launches.");
          return;
        }

        setLoading(true);

        Promise.all(boxesToSubmit.map(function (box) { return subscribeOne(box, email); }))
          .then(function (results) {
            setLoading(false);
            var okCount = alreadyCount;
            var failedTitles = [];

            results.forEach(function (r) {
              var success = r.ok && r.data && (r.data.status === 'subscribed' || r.data.status === 'already_subscribed');
              if (success) {
                okCount++;
                markNotified(email, r.payload.product_id);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event:               'notify_me_signup',
                  product_title:       r.payload.product_title,
                  product_id:          r.payload.product_id,
                  variant_id:          r.payload.variant_id,
                  product_handle:      r.payload.product_handle,
                  subscription_status: r.data.status
                });
              } else {
                failedTitles.push(r.productTitle);
              }
            });

            var totalSelected = boxes.length;

            if (okCount === totalSelected) {
              showSuccess(okCount === 1
                ? "You're on the list! We'll email you when it launches."
                : "You're on the list for " + okCount + " items! We'll email you as each one launches.");
            } else if (okCount > 0) {
              showSuccess("Added " + okCount + " of " + totalSelected + " items. Please retry: " + failedTitles.join(', '));
            } else {
              showError('Something went wrong. Please try again.');
            }
          });
      }

      root.addEventListener('submit', handleSubmit);
    }

    document.querySelectorAll('[data-waitlist-launch]').forEach(initWaitlistLaunch);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-waitlist-launch]');
      if (root) initWaitlistLaunch(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function () {
    const content = document.querySelector('#ArticleBody');
    const toc = document.querySelector('#TableOfContents');

    if (!content || !toc) return;

    // ✅ Include h2–h6
    const headings = content.querySelectorAll('h2, h3, h4, h5, h6');
    if (!headings.length) {
      toc.innerHTML = '<div class="fs-small">No headings found.</div>';
      return;
    }

    // Create safe slug from heading text
    const slugify = (str) => {
      return (str || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/<\/?[^>]+(>|$)/g, '') // remove html tags
        .replace(/&[^\s;]+;/g, '') // remove html entities
        .replace(/[^\w\s-]/g, '') // remove non-word
        .replace(/\s+/g, '-') // spaces to dashes
        .replace(/-+/g, '-'); // collapse dashes
    };

    // Ensure unique ids
    const usedIds = new Set();
    const ensureId = (el) => {
      let base = el.id ? el.id : slugify(el.textContent);
      if (!base) base = 'section';

      let id = base;
      let i = 2;
      while (usedIds.has(id) || document.getElementById(id)) {
        id = `${base}-${i++}`;
      }
      usedIds.add(id);
      el.id = id;
      return id;
    };

    // Build TOC HTML
    const ul = document.createElement('ul');

    headings.forEach((h) => {
      const id = ensureId(h);

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = h.textContent.trim();

      // ✅ Add level class: toc-h2 ... toc-h6
      const level = h.tagName.toLowerCase(); // "h2", "h3", ...
      a.classList.add(`toc-${level}`);

      li.appendChild(a);
      ul.appendChild(li);
    });

    toc.innerHTML = '';
    toc.appendChild(ul);

    // Smooth scroll + offset for sticky header (adjust if needed)
    const HEADER_OFFSET = 80;

    toc.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;

      const targetId = link.getAttribute('href').slice(1);
      const targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      e.preventDefault();
      const y = targetEl.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;

      window.scrollTo({ top: y, behavior: 'smooth' });
      history.replaceState(null, '', `#${targetId}`);
    });

    // Optional: active state while scrolling
    const links = toc.querySelectorAll('a[href^="#"]');

    const setActive = (id) => {
      links.forEach((l) =>
        l.classList.toggle('is-active', l.getAttribute('href') === `#${id}`)
      );
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((en) => en.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visible.length) setActive(visible[0].target.id);
      },
      {
        root: null,
        rootMargin: `-${HEADER_OFFSET}px 0px -70% 0px`,
        threshold: 0.01,
      }
    );

    headings.forEach((h) => observer.observe(h));
  })();

  } catch(e) { console.error(e); }
})();
})();
